export default [
  {
    name: 'Dashboard',
    menu: '/dashboard',
    url: '/dashboard',
    className: 'icon-Home mt-4 mb-2'
  },
  {
    name: 'Accounts',
    className: 'icon-Account',
    url: '/accounts',
    onlyShowIfHasChildren: true,
    children:
      [
        {
          name: 'Machines',
          url: '/:accountID/machines',
          exact: true
        },
        {
          name: 'Operators',
          url: '/:accountID/operators',
          exact: true
        },
        {
          name: 'Activities',
          url: '/:accountID/activities',
          exact: true
        },
        {
          name: 'Materials',
          url: '/:accountID/materials',
          exact: true
        },
        {
          name: 'Trucks',
          url: '/:accountID/trucks',
          exact: true
        },
        {
          name: 'Shifts',
          url: '/:accountID/shifts',
          exact: true
        },
        {
          name: 'Licenses',
          url: '/:accountID/licenses',
          exact: true
        },
        {
          name: 'License Journals',
          url: '/:accountID/licenseJournals',
          exact: true
        },
        {
          name: 'Notifications',
          url: '/:accountID/notifications',
          exact: true
        },
        {
          name: 'Data Import',
          url: '/:accountID/dataImport',
          exact: false
        },
      ]
  },
  {
    name: 'Configs',
    className: 'icon-Machine-Settings',
    url: '/configs',
    onlyShowIfHasChildren: true,
    children:
      [
        {
          name: 'Overview',
          url: '/:accountID/overview',
          exact: true
        },
      ]
  },
  {
    name: 'Transfers',
    className: 'icon-Data-Transfer',
    url: '/transfers',
    children:
      [
        {
          name: 'Configuration',
          url: '/:accountID/configurations',
          exact: true
        },
        {
          name: 'Mine Plans',
          url: '/:accountID/mineplans',
          exact: false
        },
        {
          name: 'Machine Mine Plans',
          url: '/:accountID/machinemineplans',
          exact: false
        },
        {
          name: 'Edge File Exports',
          url: '/:accountID/edgefileexports',
          exact: false
        },
        {
          name: 'Licenses',
          url: '/:accountID/licenses',
          exact: true
        },
      ]
  },
  {
    name: 'Reports',
    className: 'icon-Report',
    url: '/reports',
    children:
      [
        {
          name: 'Reports',
          url: '',
          exact: true
        },
        {
          name: 'Schedule',
          url: '/schedule',
          exact: true
        },
      ]
  },
  {
    name: 'Analytics',
    className: 'icon-Analytics',
    url: '/analytics'
  },
  {
    name: 'System',
    linkClassName: 'last-group',
    className: 'icon-Global-System',
    url: '/system',
    noShow: true,
    children:
      [
        {
          name: 'Sites',
          url: '/sites',
          exact: true
        },
        {
          name: 'Accounts',
          url: '/accounts',
          exact: true
        },
      ]
  },
  {
    name: 'Settings',
    className: 'icon-User-Account',
    noShow: true,
    url: '/settings',
    children:
      [
        {
          name: 'Users',
          url: '/users',
          exact: true
        },
        {
          name: 'Email logs',
          url: '/inboundEmailLogs',
          exact: true
        },
      ]
  }
];
